import { useState } from 'react';

export const panelNames = {
  scene: 'scene',
  video: 'video',
};

export const usePreviewState = () => {
  const [currentPanel, setCurrentPanel] = useState('scene');
  const isScenePanel = currentPanel === panelNames.scene;

  return {
    currentPanel,
    setCurrentPanel,
    isScenePanel,
  };
};
